import React from 'react';
import { MessageSquare, AlertTriangle } from 'react-feather';
import { Tooltip } from '../ui/Tooltip';
import './ManagerDiscussionMarker.css';

/**
 * Marker shown on task cards to indicate that manager discussions have taken
 * place for a task. Discussions are triggered when a task is overrunning, so
 * the count is a criticality signal: the more discussions, the more the styling
 * escalates (low -> warning -> critical). Renders nothing when there are none.
 */
const getSeverity = (count) => {
    if (count >= 3) {
        return {
            level: 'critical',
            Icon: AlertTriangle,
            label: `Critical: ${count} manager discussions — task persistently overrunning`
        };
    }
    if (count === 2) {
        return {
            level: 'warning',
            Icon: MessageSquare,
            label: '2 manager discussions — task repeatedly running long'
        };
    }
    return {
        level: 'low',
        Icon: MessageSquare,
        label: '1 manager discussion — task flagged as running long'
    };
};

const ManagerDiscussionMarker = ({ count = 0 }) => {
    if (!count || count <= 0) return null;

    const { level, Icon, label } = getSeverity(count);

    return (
        <Tooltip content={label}>
            <span
                className={`manager-discussion-marker manager-discussion-marker--${level}`}
                aria-label={label}
            >
                <Icon size={10} className="manager-discussion-marker-icon" />
                <span className="manager-discussion-marker-count">{count}</span>
            </span>
        </Tooltip>
    );
};

export default ManagerDiscussionMarker;
